module.exports = __webpack_public_path__ + "static/img/bg.f270f55c.png";